import React from 'react'
import { useKhmdDelMutation } from '../../store/BnsKeJiApi'
import { App } from 'antd';
function ContactDel(props) {
    const {modal,message} = App.useApp(); 
    const [del] = useKhmdDelMutation()
    return (
        <a onClick={() => {
            modal.confirm({
                title: '确定删除吗?',
                content: '删除后不能恢复',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    del({khmd_id:props.khmd_id}).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                console.log('Cancel');
                },
            });
        }}>删除</a>
    )
}

export default ContactDel